/**
 * FCC Broadband Data Collection (BDC) — county-level coverage lookup.
 * Generated by data_raw/build_broadband.R from the BDC J25 (June 30, 2025)
 * filing, as published 14 April 2026.
 *
 * Value: percent of residential broadband-serviceable locations with at
 * least one provider offering ≥100/20 Mbps service via wired or licensed
 * fixed wireless technology. Excludes satellite and unlicensed fixed
 * wireless to match the FCC's BEAD-eligibility footprint.
 *
 * Source: https://broadbandmap.fcc.gov/data-download/nationwide-data
 */

let _data = null;
let _loadPromise = null;

export function loadBroadbandData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/broadband.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load broadband data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getBroadband(stateFips, countyFips) {
  if (!_data) return null;
  const key = `${String(stateFips).padStart(2, "0")}${String(countyFips).padStart(3, "0")}`;
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

const broadband = { loadBroadbandData, getBroadband };
export default broadband;
